<ng-select
  #select
  [ngModel]="selectedItemId$ | async"
  (ngModelChange)="onSelect($event)"
  [items]="items"
  [bindValue]="'id'"
  [clearable]="false"
  [readonly]="false"
  [searchable]="false"
  [virtualScroll]="true"
>
  <ng-template ng-label-tmp let-item="item">
    {{ item?.translationKey | translate }}
  </ng-template>

  <ng-template ng-option-tmp let-item="item">
    {{ item?.translationKey | translate }}
  </ng-template>
</ng-select>
